import { Box, Dialog, DialogContent, IconButton } from '@material-ui/core'
import CloseIcon from '@mui/icons-material/Close'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import React, { useState } from 'react'
import ReactPlayer from 'react-player'

const PlayerComponent = ({ url, onDialogCancel }) => {
  const [isPlaying, setIsPlaying] = useState(false)

  if (!url) {
    return <></>
  }

  const isImage = url.match(/\.(png|jpg|jpeg|gif|webp)$/i) || url.includes('images') // Second check can be removed when we move things to Prodcution
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={true}
      onClose={onDialogCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <IconButton
        aria-label="close"
        onClick={onDialogCancel}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme => theme.palette.grey[500],
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        {!isImage && (
          <Box
            sx={{
              position: 'relative',
              width: '100%',
              maxHeight: '80vh',
              aspectRatio: '16 / 9',
            }}
          >
            <ReactPlayer
              width="100%"
              height="100%"
              url={url}
              controls
              playing={isPlaying}
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
              config={{
                file: {
                  attributes: {
                    style: { width: '100%', height: '100%', objectFit: 'contain' },
                  },
                },
              }}
            />
            {!isPlaying && (
              <IconButton
                aria-label="play video"
                onClick={() => setIsPlaying(true)}
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'rgba(0, 0, 0, 0.5)',
                  color: '#fff',
                  '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                }}
              >
                <PlayArrowIcon fontSize="large" />
              </IconButton>
            )}
          </Box>
        )}
        {isImage && (
          <img
            src={url}
            alt='Preview-image'
            loading="lazy"
            style={{
              maxWidth: '100%',
              maxHeight: '80vh',
              width: 'auto',
              height: 'auto',
              objectFit: 'contain',
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}

export default PlayerComponent
